//add asterisk for search words 
          
if ($('#q-input')[0]) {
  var qvalueStr = $('#q-input').val();
  qvalueStr = qvalueStr.replace(/\*/g, '').replace(/(^\s+|\s+$)/gm, '');
  $('#q-input').val(qvalueStr);

  $('.container [action="/search"]').on("submit", function() {
    addAsterisk();
  });

  function addAsterisk() {
    var qvalue = $('#q-input').val();
    var qvalueStr = qvalue.split(" ");
    var newqvalue = "";
    for (var i = 0; i < qvalueStr.length; i++) {
      newqvalue += qvalueStr[i].replace(/\*/g, '') + "* ";
    }
    $('.container [name="q"]').val(newqvalue);
  }

}


if ($('#q-search-input')[0]) {

  var qvalueStr = $('#q-search-input').val();
  qvalueStr = qvalueStr.replace(/\*/g, '').replace(/(^\s+|\s+$)/gm, '');
  $('#q-search-input').val(qvalueStr);


  $('.search__inner [action="/search"]').on("submit", function() {
    addAsterisk2();
  });

  function addAsterisk2() {
    var qvalue = $('#q-search-input').val();
    var qvalueStr = qvalue.split(" ");
    var newqvalue = "";
    for (var i = 0; i < qvalueStr.length; i++) {
      newqvalue += qvalueStr[i].replace(/\*/g, '') + "* ";
    }
    $('.search__inner [name="q"]').val(newqvalue);
  }

}